import styled from 'styled-components';
import { ImageButtonStyled } from '../ImageButtonStyled';
import { rem } from 'polished';

export const ImageButtonStyledAP = styled(ImageButtonStyled)`
    .img-btn-container {
        text-decoration: none;

        &.active {
            background: transparent;
            .description {
                :after {
                    visibility: visible;
                }
            }
            &:hover {
                box-shadow: none;
            }
        }

        img {
            max-height: ${rem(200)};
        }

        .sum {
            background-color: ${({ theme }) => theme.colors.primary};
        }

        .top .sum {
            font-size: ${rem(10)};
        }

        .top h1 {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }

        .description {
            display: none;
        }
    }
`;
